import './PreventiveDetailsHeader.scss';

import { useDispatch } from "react-redux";

import { useParams } from "react-router-dom";

import { openModal } from "../../../../../slices/modalSlice";
import { openDrawer } from "../../../../../slices/drawerSlice";

import Bookmark from "@mui/icons-material/Bookmark";
import Add from "@mui/icons-material/Add";

import { TextButton } from "../../../../../common-components/Buttons/Buttons";
import { LargeTitle } from "../../../../../common-components/Titles/Titles";
import { Button } from "../../../../../common-components/Buttons/Buttons";

import PreventiveLinksModal from "../../../PreventiveLinksModal/PreventiveLinksModal";
import PreventiveIssueCreate from "../../../PreventiveIssueCreate/PreventiveIssueCreate";
import PreventiveIssueCreateFooter
    from "../../../PreventiveIssueCreate/components/PreventiveIssueCreateFooter/PreventiveIssueCreateFooter";

const PreventiveDetailsHeader = () => {
    const dispatch = useDispatch();
    const { id } = useParams();

    const handleOpenModal = () => {
        dispatch(openModal({content: <PreventiveLinksModal/>, closeable: true}));
    }

    const handleOpen = () => {
        dispatch(openDrawer({content: <PreventiveIssueCreate id={id}/>, footer: <PreventiveIssueCreateFooter id={id}/>, tools: <TextButton Icon={Bookmark} title={"Правила пром.безопасности"} active={true} onClick={handleOpenModal} color={"#01579b"}/>}));
    }


    return (
        <div className={"preventive-details-header"}>
            <div className={"preventive-details-header_container"}>
                <div className={"preventive-details-header_title"}>
                    <LargeTitle property={"Нарушения"}/>
                </div>
                <div className={"preventive-details-header_button"}>
                    <Button Icon={Add} title={"Добавить"} onClick={handleOpen}/>
                </div>
            </div>
        </div>
    )
}

export default PreventiveDetailsHeader;